import React from "react";
import {
  Modal,
  Button,
} from "react-bootstrap";

export default function DeletePayrollModal({
  show,
  handleClose,
  handleDelete,
}) {

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
    >

      <Modal.Body className="text-center p-4">

        <h4 className="mb-3">
          Delete Item?
        </h4>

        <p className="text-muted">
          This action cannot be undone
        </p>

        <div className="d-flex gap-3 mt-4">

          <Button
            variant="light"
            className="w-50"
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            variant="danger"
            className="w-50"
            onClick={handleDelete}
          >
            Delete
          </Button>

        </div>

      </Modal.Body>

    </Modal>
  );
}